import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-thin-arrow-right",
  "use": "icon-thin-arrow-right-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"currentColor\" id=\"icon-thin-arrow-right\">\n  <g id=\"icon-thin-arrow-right_Thin_Arrow_Right\">\n    <path d=\"M7.606,4L7.171,4.366L11.959,10l-4.787,5.634L7.606,16l5.222-6L7.606,4z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol